import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import langEN from '../src/assets/locales/translation-en.json';
import langFR from '../src/assets/locales/translation-fr.json';
import langDE from '../src/assets/locales/translation-de.json';
import langSE from '../src/assets/locales/translation-se.json';

const resources = {
    en: { translations: { ...langEN, } },
    fr: { translations: { ...langFR, } },
    de: { translations: { ...langDE, } },
    se: { translations: { ...langSE, } }
};
i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: resources,
        fallbackLng: 'en',
        debug: true,
        ns: ["translations"],
        defaultNS: "translations",
        interpolation: {
            escapeValue: false
        }
    })

export default i18next;